import { computed, inject } from 'vue'

const ADMIN_PERMISSIONS_KEY = 'adminPermissions'

export const useAdminPermissions = () => {
  const injectedPermissions = inject(ADMIN_PERMISSIONS_KEY, computed(() => []))

  const permissions = computed(() => {
    const value = injectedPermissions?.value
    return Array.isArray(value) ? value : []
  })

  const hasPermission = (code) => permissions.value.includes(code)
  const hasAnyPermission = (codes = []) => codes.some((code) => hasPermission(code))

  return {
    permissions,
    hasPermission,
    hasAnyPermission,
  }
}

export { ADMIN_PERMISSIONS_KEY }
